import { render, staticRenderFns } from "./addSample.vue?vue&type=template&id=600b6e69&scoped=true"
import script from "./addSample.vue?vue&type=script&lang=js"
export * from "./addSample.vue?vue&type=script&lang=js"
import style0 from "./addSample.vue?vue&type=style&index=0&id=600b6e69&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "600b6e69",
  null
  
)

export default component.exports